// extracted by mini-css-extract-plugin
module.exports = {"container":"VipCodeSection_container__2elE6"};